import SvgIcon from "@mui/material/SvgIcon";

export function BedIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.3333 6.87133V2.5H11.9999V3.83333H3.99992V2.5H2.66659V6.87133C1.87325 7.33333 1.33325 8.18333 1.33325 9.16667V11.8333C1.33325 12.0101 1.40349 12.1797 1.52851 12.3047C1.65354 12.4298 1.82311 12.5 1.99992 12.5H2.66659V15.1667H3.99992V12.5H11.9999V15.1667H13.3333V12.5H13.9999C14.1767 12.5 14.3463 12.4298 14.4713 12.3047C14.5963 12.1797 14.6666 12.0101 14.6666 11.8333V9.16667C14.6666 8.18333 14.1259 7.33333 13.3333 6.87133ZM11.9999 5.16667V6.5H8.66659V5.16667H11.9999ZM3.99992 5.16667H7.33325V6.5H3.99992V5.16667ZM13.3333 11.1667H2.66659V9.16667C2.66659 8.43133 3.26459 7.83333 3.99992 7.83333H11.9999C12.7353 7.83333 13.3333 8.43133 13.3333 9.16667V11.1667Z"
          fill="#054D87"
        />
      </svg>
    </SvgIcon>
  );
}
export function ShowerIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.2 13.564C15.0512 12.583 14.6361 11.6615 14 10.9C13.3621 11.6604 12.9468 12.5824 12.8 13.564C12.7804 13.7332 12.7969 13.9047 12.8482 14.0671C12.8996 14.2295 12.9848 14.3792 13.0981 14.5064C13.2114 14.6336 13.3503 14.7354 13.5058 14.8051C13.6612 14.8748 13.8297 14.9108 14 14.9108C14.1704 14.9108 14.3388 14.8748 14.4942 14.8051C14.6497 14.7354 14.7886 14.6336 14.9019 14.5064C15.0152 14.3792 15.1004 14.2295 15.1518 14.0671C15.2031 13.9047 15.2196 13.7332 15.2 13.564ZM7.2 15.164C7.05121 14.183 6.63615 13.2615 6 12.5C5.36209 13.2604 4.9468 14.1824 4.8 15.164C4.78255 15.5001 4.89905 15.8295 5.12397 16.0799C5.3489 16.3303 5.66391 16.4814 6 16.5C6.33609 16.4814 6.6511 16.3303 6.87603 16.0799C7.10095 15.8295 7.21745 15.5001 7.2 15.164ZM10 16.5C10.3361 16.4814 10.6511 16.3303 10.876 16.0799C11.101 15.8295 11.2175 15.5001 11.2 15.164C11.0512 14.183 10.6361 13.2615 10 12.5C9.36209 13.2604 8.9468 14.1824 8.8 15.164C8.78255 15.5001 8.89905 15.8295 9.12397 16.0799C9.3489 16.3303 9.66391 16.4814 10 16.5ZM0.8 13.564C0.78255 13.9001 0.899049 14.2295 1.12397 14.4799C1.3489 14.7303 1.66391 14.8814 2 14.9C2.33609 14.8814 2.6511 14.7303 2.87603 14.4799C3.10095 14.2295 3.21745 13.9001 3.2 13.564C3.05121 12.583 2.63615 11.6615 2 10.9C1.36209 11.6604 0.946796 12.5824 0.8 13.564ZM8.8 2.156V0.5H7.2V2.156C5.65438 2.35073 4.23286 3.10252 3.20192 4.27042C2.17098 5.43833 1.60141 6.94217 1.6 8.5H0V10.1H16V8.5H14.4C14.3986 6.94217 13.829 5.43833 12.7981 4.27042C11.7671 3.10252 10.3456 2.35073 8.8 2.156ZM3.2 8.5C3.2 7.22696 3.70571 6.00606 4.60589 5.10589C5.50606 4.20571 6.72696 3.7 8 3.7C9.27304 3.7 10.4939 4.20571 11.3941 5.10589C12.2943 6.00606 12.8 7.22696 12.8 8.5H3.2Z"
          fill="#054D87"
        />
      </svg>
    </SvgIcon>
  );
}
export function SquareFootIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.33325 1.83325H7.99992V8.49992H14.6666V15.1666H1.33325V1.83325ZM2.66659 3.16659V4.83325H4.00259V6.16659H2.66659V7.83325H4.00259V9.16659H2.66659V10.8333H4.00259V12.1666H2.66659V13.8333H4.33325V12.5219H5.66659V13.8333H7.33325V12.5219H8.66659V13.8333H10.3333V12.5219H11.6666V13.8333H13.3333V9.83325H6.66659V3.16659H2.66659Z"
          fill="#054D87"
        />
      </svg>
    </SvgIcon>
  );
}
export function MarkerIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7 8.1665C8.10457 8.1665 9 7.27107 9 6.1665C9 5.06193 8.10457 4.1665 7 4.1665C5.89543 4.1665 5 5.06193 5 6.1665C5 7.27107 5.89543 8.1665 7 8.1665Z"
          stroke={props.color || "#054D87"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.00008 0.833252C5.58559 0.833252 4.22904 1.39516 3.22885 2.39535C2.22865 3.39554 1.66675 4.7521 1.66675 6.16659C1.66675 7.42792 1.93475 8.25325 2.66675 9.16659L7.00008 14.1666L11.3334 9.16659C12.0654 8.25325 12.3334 7.42792 12.3334 6.16659C12.3334 4.7521 11.7715 3.39554 10.7713 2.39535C9.77112 1.39516 8.41457 0.833252 7.00008 0.833252Z"
          stroke={props.color || "#054D87"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function ShareIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.5 8.5V12.5C2.5 12.7652 2.60536 13.0196 2.79289 13.2071C2.98043 13.3946 3.23478 13.5 3.5 13.5H12.5C12.7652 13.5 13.0196 13.3946 13.2071 13.2071C13.3946 13.0196 13.5 12.7652 13.5 12.5V8.5M8 10V1.75M11 4.5L8 1.5L5 4.5"
          stroke={props.color || "#054D87"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function DownloadIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10M4.66667 6.66667L8 10M8 10L11.3333 6.66667M8 10V2"
          stroke="#054D87"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function CubeIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.2708 4.05742L8.27083 1.39076C8.18551 1.35284 8.09319 1.33325 7.99983 1.33325C7.90647 1.33325 7.81415 1.35284 7.72883 1.39076L1.72883 4.05742C1.7155 4.06342 1.70616 4.07342 1.69283 4.08076C1.67416 4.09009 1.65416 4.09609 1.63683 4.10742C1.62216 4.11742 1.61083 4.13009 1.59683 4.14076C1.5481 4.17697 1.50536 4.22061 1.47016 4.27009C1.45683 4.28876 1.44283 4.30542 1.43083 4.32409C1.41099 4.35932 1.39404 4.39611 1.38016 4.43409C1.37416 4.45209 1.36483 4.46876 1.3595 4.48676C1.34275 4.54531 1.33401 4.60586 1.3335 4.66676V11.3334C1.3335 11.5974 1.48816 11.8354 1.7295 11.9428L7.7295 14.6094C7.81616 14.6481 7.90816 14.6668 8.00016 14.6668C8.09299 14.6644 8.18428 14.6426 8.26816 14.6028L8.27083 14.6094L14.2708 11.9428C14.3888 11.8905 14.489 11.805 14.5593 11.6969C14.6296 11.5887 14.6669 11.4624 14.6668 11.3334V4.66676C14.6669 4.53775 14.6296 4.41149 14.5593 4.30332C14.489 4.19515 14.3888 4.10972 14.2708 4.05742ZM8.00016 2.73009L12.3588 4.66676L8.00016 6.60342L3.64216 4.66676L8.00016 2.73009ZM2.66683 10.9008V5.69275L7.3335 7.76676V12.9741L2.66683 10.9008ZM8.66683 12.9741V7.76676L13.3335 5.69275V10.9008L8.66683 12.9741Z"
          fill={props.color || "black"}
        />
      </svg>
    </SvgIcon>
  );
}
export function InPersonIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6 14.0001V10.0001C6 9.64646 6.14048 9.30732 6.39052 9.05727C6.64057 8.80722 6.97971 8.66675 7.33333 8.66675H8.66667C8.83133 8.66675 8.98933 8.69675 9.13467 8.75141"
          stroke={props.color || "black"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.6667 8H14L8 2L2 8H3.33333V12.6667C3.33333 13.0203 3.47381 13.3594 3.72386 13.6095C3.97391 13.8595 4.31304 14 4.66667 14H8M10.6667 14.6667L14 11.3333M14 11.3333V14.3333M14 11.3333H11"
          stroke={props.color || "black"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function InVideoIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.49967 11.9999H8.50634M5.16634 1.33325H11.833C12.5694 1.33325 13.1663 1.93021 13.1663 2.66659V13.3333C13.1663 14.0696 12.5694 14.6666 11.833 14.6666H5.16634C4.42996 14.6666 3.83301 14.0696 3.83301 13.3333V2.66659C3.83301 1.93021 4.42996 1.33325 5.16634 1.33325Z"
          stroke={props.color || "black"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function StreetViewIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.83203 2C7.73203 2 6.83203 2.9 6.83203 4C6.83203 4.5565 7.07053 5.0585 7.44153 5.422C7.10132 5.65179 6.8224 5.96122 6.62903 6.32338C6.43566 6.68554 6.33371 7.08946 6.33203 7.5V9.8125L7.33203 10.3125V12.5H10.332V10.3125L11.332 9.8125V7.5C11.3304 7.08946 11.2284 6.68554 11.035 6.32338C10.8417 5.96122 10.5627 5.65179 10.2225 5.422C10.5935 5.0585 10.832 4.557 10.832 4C10.832 2.9 9.93203 2 8.83203 2ZM8.83203 3C9.39053 3 9.83203 3.4415 9.83203 4C9.83203 4.5585 9.39053 5 8.83203 5C8.27353 5 7.83203 4.5585 7.83203 4C7.83203 3.4415 8.27353 3 8.83203 3ZM8.83203 6C9.66603 6 10.332 6.666 10.332 7.5V9.1875L9.33203 9.6875V11.5H8.33203V9.6875L7.33203 9.1875V7.5C7.33203 6.666 7.99803 6 8.83203 6ZM5.33203 9.4375C3.87303 9.8455 2.83203 10.5375 2.83203 11.5C2.83203 13.1405 5.84953 14 8.83203 14C11.8145 14 14.832 13.1405 14.832 11.5C14.832 10.537 13.791 9.8455 12.332 9.4375V10.4845C13.283 10.791 13.832 11.1875 13.832 11.5C13.832 12.0975 11.838 13 8.83203 13C5.82603 13 3.83203 12.0975 3.83203 11.5C3.83203 11.1875 4.38103 10.791 5.33203 10.4845V9.4375Z"
          fill={props?.color || "white"}
        />
      </svg>
    </SvgIcon>
  );
}
export function SendMessageIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.16602 15.0001V18.1384L9.39685 15.0001H13.3327C14.2518 15.0001 14.9993 14.2526 14.9993 13.3334V6.66675C14.9993 5.74758 14.2518 5.00008 13.3327 5.00008H3.33268C2.41352 5.00008 1.66602 5.74758 1.66602 6.66675V13.3334C1.66602 14.2526 2.41352 15.0001 3.33268 15.0001H4.16602ZM3.33268 6.66675H13.3327V13.3334H8.93518L5.83268 15.1951V13.3334H3.33268V6.66675Z"
          fill="#054D87"
        />
        <path
          d="M16.666 1.66675H6.66602C5.74685 1.66675 4.99935 2.41425 4.99935 3.33341H14.9993C15.9185 3.33341 16.666 4.08091 16.666 5.00008V11.6667C17.5852 11.6667 18.3327 10.9192 18.3327 10.0001V3.33341C18.3327 2.41425 17.5852 1.66675 16.666 1.66675Z"
          fill="#054D87"
        />
      </svg>
    </SvgIcon>
  );
}
export function CheckedIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1004_2173)">
          <path
            d="M18.3332 9.23355V10.0002C18.3321 11.7972 17.7503 13.5458 16.6743 14.9851C15.5983 16.4244 14.0859 17.4773 12.3626 17.9868C10.6394 18.4963 8.79755 18.4351 7.1119 17.8124C5.42624 17.1896 3.98705 16.0386 3.00897 14.5311C2.03089 13.0236 1.56633 11.2403 1.68457 9.44714C1.80281 7.65402 2.49751 5.94715 3.66507 4.58111C4.83263 3.21506 6.41049 2.26303 8.16333 1.867C9.91617 1.47097 11.7501 1.65216 13.3915 2.38355M18.3332 3.33355L9.99984 11.6752L7.49984 9.17521"
            stroke={props.color || "#18A874"}
            stroke-width="1.75"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1004_2173">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
export function UserIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.6668 12.75V11.5833C11.6668 10.9645 11.421 10.371 10.9834 9.93342C10.5458 9.49583 9.95233 9.25 9.3335 9.25H4.66683C4.04799 9.25 3.4545 9.49583 3.01691 9.93342C2.57933 10.371 2.3335 10.9645 2.3335 11.5833V12.75M9.3335 4.58333C9.3335 5.872 8.28883 6.91667 7.00016 6.91667C5.7115 6.91667 4.66683 5.872 4.66683 4.58333C4.66683 3.29467 5.7115 2.25 7.00016 2.25C8.28883 2.25 9.3335 3.29467 9.3335 4.58333Z"
          stroke={props?.color || "#666666"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function EditIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M4.66667 11.8423L7.60867 11.8323L14.03 5.47226C14.282 5.22026 14.4207 4.88559 14.4207 4.52959C14.4207 4.17359 14.282 3.83893 14.03 3.58693L12.9727 2.52959C12.4687 2.02559 11.5893 2.02826 11.0893 2.52759L4.66667 8.88893V11.8423ZM12.03 3.47226L13.0893 4.52759L12.0247 5.58226L10.9673 4.52559L12.03 3.47226ZM6 9.44493L10.02 5.46293L11.0773 6.52026L7.058 10.5009L6 10.5043V9.44493Z"
          fill="#666666"
        />
        <path
          d="M3.33333 14.5002H12.6667C13.402 14.5002 14 13.9022 14 13.1669V7.38824L12.6667 8.72158V13.1669H5.43867C5.42133 13.1669 5.40333 13.1736 5.386 13.1736C5.364 13.1736 5.342 13.1676 5.31933 13.1669H3.33333V3.83358H7.898L9.23133 2.50024H3.33333C2.598 2.50024 2 3.09824 2 3.83358V13.1669C2 13.9022 2.598 14.5002 3.33333 14.5002Z"
          fill="#666666"
        />
      </svg>
    </SvgIcon>
  );
}
export function DownloadPDFIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1078_4694)">
          <path
            d="M5.33329 11.8333L7.99996 14.5M7.99996 14.5L10.6666 11.8333M7.99996 14.5V8.49996M13.92 12.56C14.4996 12.1524 14.9342 11.5707 15.1608 10.8994C15.3874 10.2281 15.3942 9.50197 15.1802 8.82651C14.9662 8.15104 14.5425 7.56135 13.9707 7.143C13.3988 6.72464 12.7085 6.4994 12 6.49996H11.16C10.9594 5.71854 10.5843 4.99279 10.0627 4.37734C9.54112 3.7619 8.88672 3.2728 8.14876 2.94686C7.4108 2.62092 6.60852 2.46664 5.80231 2.49563C4.99609 2.52463 4.20696 2.73614 3.49432 3.11424C2.78168 3.49234 2.16411 4.02719 1.68808 4.67851C1.21206 5.32983 0.88999 6.08065 0.746129 6.87445C0.602269 7.66826 0.640362 8.48435 0.857542 9.2613C1.07472 10.0383 1.46533 10.7558 1.99996 11.36"
            stroke={props?.color || "#666666"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1078_4694">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(0 0.5)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
export function ThrashIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2 4.49967H3.33333M3.33333 4.49967H14M3.33333 4.49967V13.833C3.33333 14.1866 3.47381 14.5258 3.72386 14.7758C3.97391 15.0259 4.31304 15.1663 4.66667 15.1663H11.3333C11.687 15.1663 12.0261 15.0259 12.2761 14.7758C12.5262 14.5258 12.6667 14.1866 12.6667 13.833V4.49967H3.33333ZM5.33333 4.49967V3.16634C5.33333 2.81272 5.47381 2.47358 5.72386 2.22353C5.97391 1.97348 6.31304 1.83301 6.66667 1.83301H9.33333C9.68696 1.83301 10.0261 1.97348 10.2761 2.22353C10.5262 2.47358 10.6667 2.81272 10.6667 3.16634V4.49967M6.66667 7.83301V11.833M9.33333 7.83301V11.833"
          stroke={props.color || "#F04438"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function PencilIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.1667 2.5009C14.3855 2.28203 14.6454 2.10842 14.9313 1.98996C15.2173 1.87151 15.5238 1.81055 15.8333 1.81055C16.1429 1.81055 16.4493 1.87151 16.7353 1.98996C17.0213 2.10842 17.2811 2.28203 17.5 2.5009C17.7189 2.71977 17.8925 2.97961 18.0109 3.26558C18.1294 3.55154 18.1903 3.85804 18.1903 4.16757C18.1903 4.4771 18.1294 4.7836 18.0109 5.06956C17.8925 5.35553 17.7189 5.61537 17.5 5.83424L6.24999 17.0842L1.66666 18.3342L2.91666 13.7509L14.1667 2.5009Z"
          stroke={props.color || "#535862"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function ReportNoteIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.33329 3.8335H3.99996C3.64634 3.8335 3.3072 3.97397 3.05715 4.22402C2.8071 4.47407 2.66663 4.81321 2.66663 5.16683V13.1668C2.66663 13.5205 2.8071 13.8596 3.05715 14.1096C3.3072 14.3597 3.64634 14.5002 3.99996 14.5002H7.79796M12 8.50016V5.16683C12 4.81321 11.8595 4.47407 11.6094 4.22402C11.3594 3.97397 11.0202 3.8335 10.6666 3.8335H9.33329"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.33325 7.83333H7.99992M5.33325 10.5H7.33325M12.3333 13.5L13.9999 15.1667M5.33325 3.83333C5.33325 3.47971 5.47373 3.14057 5.72378 2.89052C5.97382 2.64048 6.31296 2.5 6.66659 2.5H7.99992C8.35354 2.5 8.69268 2.64048 8.94273 2.89052C9.19278 3.14057 9.33325 3.47971 9.33325 3.83333C9.33325 4.18696 9.19278 4.52609 8.94273 4.77614C8.69268 5.02619 8.35354 5.16667 7.99992 5.16667H6.66659C6.31296 5.16667 5.97382 5.02619 5.72378 4.77614C5.47373 4.52609 5.33325 4.18696 5.33325 3.83333ZM9.33325 12.1667C9.33325 12.6087 9.50885 13.0326 9.82141 13.3452C10.134 13.6577 10.5579 13.8333 10.9999 13.8333C11.4419 13.8333 11.8659 13.6577 12.1784 13.3452C12.491 13.0326 12.6666 12.6087 12.6666 12.1667C12.6666 11.7246 12.491 11.3007 12.1784 10.9882C11.8659 10.6756 11.4419 10.5 10.9999 10.5C10.5579 10.5 10.134 10.6756 9.82141 10.9882C9.50885 11.3007 9.33325 11.7246 9.33325 12.1667Z"
          stroke="black"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function BuildingIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 2H6C4.897 2 4 2.897 4 4V21C4 21.2652 4.10536 21.5196 4.29289 21.7071C4.48043 21.8946 4.73478 22 5 22H19C19.2652 22 19.5196 21.8946 19.7071 21.7071C19.8946 21.5196 20 21.2652 20 21V4C20 2.897 19.103 2 18 2ZM18 20H6V4H18V20Z"
          fill={props?.color || "#054D87"}
        />
        <path
          d="M8 6H11V8H8V6ZM13 6H16V8H13V6ZM8 10H11V12H8V10ZM13 10.031H16V12H13V10.031ZM8 14H11V16H8V14ZM13 14H16V16H13V14Z"
          fill={props?.color || "#054D87"}
        />
      </svg>
    </SvgIcon>
  );
}
export function GarageIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.579 7.617L14.553 4.53825C14.4042 4.09011 14.1179 3.70028 13.7348 3.42413C13.3518 3.14799 12.8915 2.99958 12.4193 3H5.58075C5.10854 2.99958 4.64821 3.14799 4.26516 3.42413C3.88212 3.70028 3.59584 4.09011 3.447 4.53825L2.421 7.617C2.14846 7.73136 1.91571 7.92357 1.75188 8.16957C1.58806 8.41558 1.50044 8.70444 1.5 9V12.75C1.5 13.3148 1.81725 13.8015 2.27925 14.0573C2.2695 14.1068 2.25 14.1518 2.25 14.2035V15.75C2.25 15.9489 2.32902 16.1397 2.46967 16.2803C2.61032 16.421 2.80109 16.5 3 16.5H3.75C3.94891 16.5 4.13968 16.421 4.28033 16.2803C4.42098 16.1397 4.5 15.9489 4.5 15.75V14.25H13.5V15.75C13.5 15.9489 13.579 16.1397 13.7197 16.2803C13.8603 16.421 14.0511 16.5 14.25 16.5H15C15.1989 16.5 15.3897 16.421 15.5303 16.2803C15.671 16.1397 15.75 15.9489 15.75 15.75V14.2035C15.75 14.1518 15.7305 14.106 15.7208 14.0573C15.9558 13.9291 16.1521 13.7402 16.2892 13.5102C16.4263 13.2803 16.4991 13.0177 16.5 12.75V9C16.5 8.37825 16.119 7.84425 15.579 7.617ZM3 12.75V9H15L15.0015 12.75H3ZM5.58075 4.5H12.4185C12.7418 4.5 13.0282 4.7055 13.1302 5.013L13.9598 7.5H4.04025L4.869 5.013C4.91876 4.8636 5.01429 4.73365 5.14204 4.64157C5.26979 4.54949 5.42328 4.49996 5.58075 4.5Z"
          fill={props?.color || "#054D87"}
        />
        <path
          d="M4.875 12C5.49632 12 6 11.4963 6 10.875C6 10.2537 5.49632 9.75 4.875 9.75C4.25368 9.75 3.75 10.2537 3.75 10.875C3.75 11.4963 4.25368 12 4.875 12Z"
          fill={props?.color || "#054D87"}
        />
        <path
          d="M13.125 12C13.7463 12 14.25 11.4963 14.25 10.875C14.25 10.2537 13.7463 9.75 13.125 9.75C12.5037 9.75 12 10.2537 12 10.875C12 11.4963 12.5037 12 13.125 12Z"
          fill={props?.color || "#054D87"}
        />
      </svg>
    </SvgIcon>
  );
}
export function CarbonFloorPlanIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.75 1.125H2.25C1.63125 1.125 1.125 1.63125 1.125 2.25V15.75C1.125 16.3687 1.63125 16.875 2.25 16.875H10.6875V15.75C10.6875 14.175 11.925 12.9375 13.5 12.9375V11.8125C11.3062 11.8125 9.5625 13.5562 9.5625 15.75H7.875V13.5H6.75V15.75H2.25V2.25H6.75V10.125H7.875V7.3125H10.125V6.1875H7.875V2.25H15.75V6.1875H13.5V7.3125H15.75V15.75H13.5V16.875H15.75C16.3687 16.875 16.875 16.3687 16.875 15.75V2.25C16.875 1.63125 16.3687 1.125 15.75 1.125Z"
          fill={props?.color || "#054D87"}
        />
      </svg>
    </SvgIcon>
  );
}
export function TargetIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_1156_31108)">
          <path
            d="M9.99984 18.3332C14.6022 18.3332 18.3332 14.6022 18.3332 9.99984C18.3332 5.39746 14.6022 1.6665 9.99984 1.6665C5.39746 1.6665 1.6665 5.39746 1.6665 9.99984C1.6665 14.6022 5.39746 18.3332 9.99984 18.3332Z"
            stroke={props?.color || "#AAAAAA"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.99984 14.9998C12.7613 14.9998 14.9998 12.7613 14.9998 9.99984C14.9998 7.23841 12.7613 4.99984 9.99984 4.99984C7.23841 4.99984 4.99984 7.23841 4.99984 9.99984C4.99984 12.7613 7.23841 14.9998 9.99984 14.9998Z"
            stroke={props?.color || "#AAAAAA"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M9.99984 11.6665C10.9203 11.6665 11.6665 10.9203 11.6665 9.99984C11.6665 9.07936 10.9203 8.33317 9.99984 8.33317C9.07936 8.33317 8.33317 9.07936 8.33317 9.99984C8.33317 10.9203 9.07936 11.6665 9.99984 11.6665Z"
            stroke={props?.color || "#AAAAAA"}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1156_31108">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
export function SendIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.6673 1.83301L7.33398 9.16634M14.6673 1.83301L10.0007 15.1663L7.33398 9.16634M14.6673 1.83301L1.33398 6.49967L7.33398 9.16634"
          stroke={props.color || "white"}
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function BadgeIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
        <path
          d="M14.375 1.25L15.3706 3.125L17.5 3.38375L15.9375 4.79187L16.25 6.875L14.375 5.70312L12.5 6.875L12.8125 4.79187L11.25 3.38375L13.4375 3.125L14.375 1.25Z"
          fill="currentColor"
        />
        <path
          d="M14.1984 8.27998L12.9874 7.96873C12.7703 8.80516 12.3102 9.55849 11.6652 10.1335C11.0202 10.7086 10.2192 11.0796 9.36343 11.1996C8.50767 11.3197 7.63553 11.1834 6.85719 10.808C6.07885 10.4326 5.42923 9.83489 4.99041 9.09046C4.55159 8.34603 4.34325 7.48824 4.39172 6.62546C4.44018 5.76268 4.74327 4.93362 5.2627 4.24302C5.78213 3.55241 6.49459 3.03126 7.31007 2.74538C8.12556 2.45951 9.00748 2.42174 9.84441 2.63686L10.1563 1.42655C8.93651 1.10972 7.64563 1.21217 6.4911 1.71743C5.33656 2.22269 4.38541 3.10142 3.79048 4.21241C3.19556 5.32341 2.9914 6.60215 3.21083 7.84315C3.43026 9.08415 4.06053 10.2154 5.00035 11.055V18.7494L8.75035 16.2494L12.5004 18.7494V11.0667C13.3304 10.3269 13.9215 9.35683 14.1984 8.27998ZM11.2504 16.4135L8.75035 14.747L6.25035 16.4135V11.9056C7.02599 12.2953 7.88187 12.4986 8.74989 12.4992C9.61791 12.4999 10.4741 12.298 11.2504 11.9095V16.4135Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}
export function OpenBookIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
        <path
          d="M9.99935 5.83333C9.99935 4.94928 9.64816 4.10143 9.02304 3.47631C8.39792 2.85119 7.55007 2.5 6.66602 2.5H1.66602V15H7.49935C8.16239 15 8.79828 15.2634 9.26712 15.7322C9.73596 16.2011 9.99935 16.837 9.99935 17.5M9.99935 5.83333V17.5M9.99935 5.83333C9.99935 4.94928 10.3505 4.10143 10.9757 3.47631C11.6008 2.85119 12.4486 2.5 13.3327 2.5H18.3327V15H12.4993C11.8363 15 11.2004 15.2634 10.7316 15.7322C10.2627 16.2011 9.99935 16.837 9.99935 17.5"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
export function PersonSupportIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
        <path
          d="M8.46177 12.311L8.45427 12.2935C8.3416 12.2627 8.22989 12.2285 8.11927 12.191L8.11094 12.1877C6.95974 11.7938 5.96051 11.0498 5.25312 10.0599C4.54574 9.0699 4.1656 7.88354 4.16594 6.66682C4.16557 5.17358 4.73786 3.73705 5.76493 2.65312C6.792 1.5692 8.19564 0.920418 9.68674 0.840416C11.1778 0.760414 12.6428 1.25528 13.78 2.22309C14.9172 3.1909 15.6399 4.55794 15.7993 6.04265C15.8359 6.38599 15.5526 6.66682 15.2076 6.66682C14.8626 6.66682 14.5868 6.38515 14.5409 6.04349C14.4301 5.23705 14.1065 4.47466 13.6035 3.83469C13.1004 3.19472 12.436 2.70025 11.6785 2.40209C10.9211 2.10394 10.0979 2.01285 9.29358 2.1382C8.48926 2.26354 7.73283 2.6008 7.10202 3.11531C6.47122 3.62982 5.98879 4.30301 5.70432 5.06572C5.41986 5.82842 5.34361 6.65311 5.48342 7.45504C5.62323 8.25696 5.97406 9.0072 6.49984 9.62864C7.02563 10.2501 7.7074 10.7203 8.4751 10.991C8.62975 10.6414 8.89986 10.3556 9.24015 10.1815C9.58045 10.0074 9.97024 9.95561 10.3442 10.0347C10.7182 10.1138 11.0536 10.3191 11.2942 10.6161C11.5349 10.9131 11.6661 11.2837 11.6659 11.666C11.6659 12.1643 11.4476 12.611 11.1018 12.916C10.7974 13.1848 10.4054 13.3333 9.99927 13.3335C9.6705 13.3347 9.34881 13.2381 9.07505 13.056C8.80129 12.874 8.58782 12.6146 8.46177 12.311ZM6.66344 12.9168C6.04924 12.5886 5.4868 12.1716 4.99427 11.6793C4.53772 11.7324 4.11658 11.9514 3.81086 12.2946C3.50514 12.6378 3.33613 13.0814 3.33594 13.541V14.0227C3.33594 14.766 3.60094 15.486 4.08427 16.0518C5.38927 17.5802 7.3776 18.3352 9.99927 18.3352C12.6209 18.3352 14.6101 17.5802 15.9176 16.0518C16.4021 15.4858 16.6684 14.7652 16.6684 14.0202V13.541C16.6684 13.044 16.4711 12.5673 16.1199 12.2158C15.7686 11.8642 15.2921 11.6664 14.7951 11.666H12.9159C12.9159 12.1143 12.8159 12.5377 12.6351 12.916H14.7951C14.9606 12.9164 15.1191 12.9825 15.236 13.0996C15.3528 13.2168 15.4184 13.3755 15.4184 13.541V14.0202C15.4186 14.4672 15.259 14.8996 14.9684 15.2393C13.9209 16.4627 12.2818 17.0843 9.99927 17.0843C7.71677 17.0843 6.07927 16.4627 5.0351 15.2402C4.74475 14.9006 4.58517 14.4686 4.5851 14.0218V13.541C4.5851 13.3752 4.65095 13.2163 4.76816 13.099C4.88537 12.9818 5.04434 12.916 5.2101 12.916L6.66344 12.9168ZM6.66594 6.66682C6.66609 6.09186 6.81496 5.52672 7.09808 5.0263C7.3812 4.52588 7.78895 4.1072 8.2817 3.81095C8.77446 3.51469 9.33546 3.35092 9.91022 3.33556C10.485 3.3202 11.0539 3.45377 11.5618 3.72328C12.0697 3.9928 12.4992 4.3891 12.8086 4.87368C13.1181 5.35827 13.2969 5.91465 13.3278 6.48878C13.3587 7.06291 13.2405 7.63526 12.9848 8.15022C12.7291 8.66518 12.3445 9.10525 11.8684 9.42765C11.344 8.98988 10.6824 8.75011 9.99927 8.75015C10.5518 8.75015 11.0817 8.53066 11.4724 8.13996C11.8631 7.74926 12.0826 7.21936 12.0826 6.66682C12.0826 6.11429 11.8631 5.58438 11.4724 5.19368C11.0817 4.80298 10.5518 4.58349 9.99927 4.58349C9.44674 4.58349 8.91683 4.80298 8.52613 5.19368C8.13543 5.58438 7.91594 6.11429 7.91594 6.66682C7.91594 7.21936 8.13543 7.74926 8.52613 8.13996C8.91683 8.53066 9.44674 8.75015 9.99927 8.75015C9.2876 8.75015 8.63594 9.00515 8.13094 9.42765C7.67918 9.12278 7.30929 8.71153 7.05383 8.2301C6.79836 7.74867 6.66516 7.21183 6.66594 6.66682Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
}
